﻿function setHeroAds() {
    if (window.desktop != null) {
        let $body = $("body");
        let width = $(document).width();
        let heroContainer = $('.hero-takeover-container');

        $body.addClass('hero-takeover-active');
        const isTablet = width <= 976 && width > 767;
        const isMobile = width <= 767;

        if (isTablet) {
            heroContainer.html(getHtml(window.tablet, window.clickTag));
        } else if (isMobile) {
            heroContainer.html(getHtml(window.mobile, window.clickTag));
            $(".site-content-top").css('height', '400px');
        } else {
            heroContainer.html(getHtml(window.desktop, window.clickTag));
            $(".site-content-top").css('height', '500px');
        }
    }
}

function getHtml(file, link) {
    return $("" +
        "<a href='" + link + "' target='_blank'>" +
        "<div class=\"overlay-ad advert\" style=\"background:url('" +
        file +
        "') center top no-repeat;\">" +
        "</div>" +
        "</a>");
}

export function setupAdHeroTakeover() {
    $(window).resize(function () {
        setHeroAds();
    });

    window.setHeroTakeover = function (desktop, tablet, mobile, clickTag) {
        window.desktop = desktop;
        window.tablet = tablet;
        window.mobile = mobile;
        window.clickTag = clickTag;
        $(window).resize();
    }
}